import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { companyQueryKeys } from "@/company/data/companyQueryKeys";
import { ErrorResponse } from "@reflag/shared/api";
import {
  EntityFlagsResponse,
  UpdateEntityFlagsBody,
} from "@reflag/shared/flagAPI";

export function useUpdateCompanyFlagAccessMutation(companyId: string) {
  const { appId, envId } = useEnvironment();
  const queryClient = useQueryClient();

  return useMutation<
    EntityFlagsResponse,
    AxiosError<ErrorResponse>,
    UpdateEntityFlagsBody
  >({
    mutationFn: (variables) => {
      if (!appId || !companyId || !envId) {
        throw new Error("Missing required parameters");
      }

      return api
        .patch<"/apps/:appId/envs/:envId/companies/:companyId/flags">(
          `/apps/${appId}/envs/${envId}/companies/${encodeURIComponent(companyId)}/flags`,
          variables,
        )
        .then((response) => response.data);
    },

    onSuccess: () => {
      if (appId && companyId && envId) {
        // Invalidate company flags
        queryClient.invalidateQueries({
          queryKey: companyQueryKeys.flags(appId, envId, companyId),
        });
      }
    },
  });
}
